import { t } from '@ankr.com/common';

import { Dialog } from 'uiKit/Dialog';

import { TFAInput } from './components/TFAInput';
import { useTFADialog } from './hooks/useTFADialog';
import { useTFADialogStyles } from './useTFADialogStyles';

export const TFADialog = () => {
  const {
    handleClose,
    handleResetTFAError,
    handleSetTOTP,
    isOpened,
    isTFAEndpointRefetching,
    tfaError,
  } = useTFADialog();

  const { classes } = useTFADialogStyles();

  return (
    <Dialog
      maxPxWidth={600}
      onClose={handleClose}
      open={isOpened}
      title={
        <span className={classes.title}>
          {t('user-settings.2fa.enter-code-dialog.title')}
        </span>
      }
    >
      <TFAInput
        buttonText={t('user-settings.2fa.enter-code-dialog.button')}
        errorMessage={tfaError}
        isLoading={isTFAEndpointRefetching}
        onConfirm={handleSetTOTP}
        onReset={handleResetTFAError}
      />
    </Dialog>
  );
};
